(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    function selectRoviaEnquiry() {
    if (window.location.hash !== '#custom-request') return;
    const form = document.querySelector('#custom-request form');
    if (!form || form.dataset.roviaTopicTouched) return;
    const option = form.querySelector('[data-custom-topic]');
    if (option) option.selected = true;
  }
  document.addEventListener('change', (event) => {
    if (event.target.matches('#custom-request select')) {
      event.target.form.dataset.roviaTopicTouched = 'true';
    }
  });
  selectRoviaEnquiry();
  window.addEventListener('hashchange', selectRoviaEnquiry);
  document.addEventListener('shopify:section:load', selectRoviaEnquiry);
  } catch(e) { console.error(e); }
})();

})();
